import { setIsOpenReferralModal } from '../redux/mainReducer';
import ApiService from './apiHelper';
import { enqueueSnackbar } from 'notistack';

const api = new ApiService('auth/payment-by-card');
const apiBoosters = new ApiService('auth/payment-for-boosters');

export const makePayment = (dispatch, type, promotionCode = '') => {
  const getDesc = () => {
    switch (type) {
      case 'MONTH_PREMIUM':
        return 'Преміум “Місяць”';
      case 'THREE_MONTH_PREMIUM':
        return 'Преміум “3 місяці”';
      case 'YEAR_PREMIUM':
        return 'Преміум “Рік”';
      case 'FREE_TRIAL_PREMIUM':
        return 'Преміум “Пробний період на місяць”';
      default:
        return;
    }
  };

  const newWindow = window.open('', '_blank');

  api
    .sendRequest({
      description: getDesc(),
      subscriptionType: type,
      promotionCode: promotionCode
    })
    .then((res) => {
      if (promotionCode) {
        dispatch(setIsOpenReferralModal(false));
      }
      const url = res?.result?.pageUrl;
      if (!url || !newWindow) return;
      newWindow.location.href = url;
    })
    .catch((error) => {
      enqueueSnackbar(error, { variant: 'error' });
      if (newWindow) {
        newWindow.close();
      }
    });
};

export const makePaymentBooster = (dispatch, value) => {
  const newWindow = window.open('', '_blank');
  apiBoosters
    .sendRequest({
      description: `${value} ${value === 1 ? 'бустер' : 'бустерів'}`,
      boosterAmount: value
    })
    .then((res) => {
      const url = res?.result?.pageUrl;
      if (!url || !newWindow) return;
      newWindow.location.href = url;
    })
    .catch((error) => {
      console.error(error);
      if (newWindow) {
        newWindow.close();
      }
    });
};
